module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('div', {
    staticClass: "login-content"
  }, [_c('el-row', {
    staticClass: "header"
  }, [_c('el-col', {
    staticClass: "header-logo",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "eg-logo"
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "header-title",
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.$t('register')))]), _vm._v(" "), _c('el-col', {
    staticClass: "header-close",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.closeRegisterPopup
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-content"
  }, [_c('i', {
    staticClass: "fa fa-user left-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.account),
      expression: "form.account"
    }],
    staticClass: "middle-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inputAccount')
    },
    domProps: {
      "value": _vm._s(_vm.form.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.account = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.submitClicked && !_vm.form.account) ? _c('div', {
    staticClass: "input-message"
  }, [_vm._v(_vm._s(_vm.$t('accountNotEmpty')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-content"
  }, [_c('i', {
    staticClass: "fa fa-lock left-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "middle-input",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('inputPassword')
    },
    domProps: {
      "value": _vm._s(_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.submitClicked && !_vm.form.password) ? _c('div', {
    staticClass: "input-message"
  }, [_vm._v(_vm._s(_vm.$t('passwordNotEmpty')))]) : _vm._e()]), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "check-btn",
    domProps: {
      "value": (_vm.checked)
    },
    on: {
      "input": function($event) {
        _vm.checked = $event
      }
    }
  }, [_c('a', {
    staticClass: "service",
    attrs: {
      "href": "http://egcenter.enjoygame.com/html/terms_of_service?lang=zh-TW"
    }
  }, [_vm._v(_vm._s(_vm.$t('service')))])]), _vm._v(" "), _c('el-button', {
    staticClass: "login-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24437d94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/store/Register.vue
// module id = 370
// module chunks = 3